// extracted by mini-css-extract-plugin
export default {"payPalModeSection":"D8-z"};